import { IndexRoute } from "react-router";
import { t } from "ttag";

import { createAdminRouteGuard } from "metabase/admin/utils";
import { AdminSettingsLayout } from "metabase/common/components/AdminLayout/AdminSettingsLayout";
import { Route } from "metabase/hoc/Title";
import { PLUGIN_METABOT, PLUGIN_REDUCERS } from "metabase/plugins";
import { hasPremiumFeature } from "metabase-enterprise/settings";

import { Metabot } from "./components/Metabot";
import { MetabotAdminPage } from "./components/MetabotAdmin/MetabotAdminPage";
import { MetabotPurchasePage } from "./components/MetabotAdmin/MetabotPurchasePage";
import { MetabotTrialPage } from "./components/MetabotAdmin/MetabotTrialPage";
import { MetabotAdminAppBarButton } from "./components/MetabotAdminAppBarButton";
import { MetabotAppBarButton } from "./components/MetabotAppBarButton";
import { getMetabotQuickLinks } from "./components/MetabotQuickLinks";
import { MetabotToggleButton } from "./components/MetabotToggleButton";
import { MetabotContext, MetabotProvider, defaultContext } from "./context";
import { getMetabotVisible, metabotReducer } from "./state";

if (hasPremiumFeature("metabot_v3")) {
  PLUGIN_METABOT.isEnabled = () => true;
  PLUGIN_METABOT.Metabot = Metabot;

  PLUGIN_METABOT.getMetabotRoutes = getMetabotQuickLinks;

  PLUGIN_METABOT.getAdminPaths = () => [
    {
      name: t`AI`,
      path: "/admin/metabot",
      key: "metabot",
    },
  ];
  PLUGIN_METABOT.getAdminRoutes = () => (
    <Route
      key="metabot"
      path="metabot"
      component={createAdminRouteGuard("metabot")}
    >
      <IndexRoute component={MetabotAdminPage} />
      <Route path=":metabotId" component={MetabotAdminPage} />
    </Route>
  );

  PLUGIN_METABOT.defaultMetabotContextValue = defaultContext;
  PLUGIN_METABOT.MetabotContext = MetabotContext;
  PLUGIN_METABOT.getMetabotProvider = () => MetabotProvider;
  // TODO: make enterprise store + fix type
  PLUGIN_METABOT.getMetabotVisible =
    getMetabotVisible as unknown as typeof PLUGIN_METABOT.getMetabotVisible;

  PLUGIN_METABOT.MetabotToggleButton = MetabotToggleButton;
  PLUGIN_METABOT.MetabotAppBarButton = MetabotAppBarButton;
  PLUGIN_METABOT.MetabotAdminAppBarButton = MetabotAdminAppBarButton;

  PLUGIN_REDUCERS.metabotPlugin = metabotReducer;
} else if (hasPremiumFeature("offer_metabase_ai_tiered")) {
  PLUGIN_METABOT.getAdminPaths = () => [
    {
      name: t`AI`,
      path: "/admin/metabot",
      key: "metabot",
    },
  ];
  PLUGIN_METABOT.getAdminRoutes = () => (
    <Route path="metabot" component={createAdminRouteGuard("metabot")}>
      <Route title={t`AI`} component={AdminSettingsLayout}>
        <IndexRoute component={MetabotPurchasePage} />
      </Route>
    </Route>
  );
} else if (hasPremiumFeature("offer_metabase_ai")) {
  PLUGIN_METABOT.getAdminPaths = () => [
    {
      name: t`AI`,
      path: "/admin/metabot",
      key: "metabot",
    },
  ];
  PLUGIN_METABOT.getAdminRoutes = () => (
    <Route path="metabot" component={createAdminRouteGuard("metabot")}>
      <Route title={t`AI`} component={AdminSettingsLayout}>
        <IndexRoute component={MetabotTrialPage} />
      </Route>
    </Route>
  );
}

/**
 * This is for Metabot in embedding
 *
 * TODO: Move this under a feature flag, but then we need to make our
 * store allowing injecting reducers dynamically since the store would
 * already be created before PLUGIN_REDUCERS.* is set via the dynamic EE plugin.
 */
PLUGIN_METABOT.getMetabotProvider = () => MetabotProvider;
PLUGIN_METABOT.defaultMetabotContextValue = defaultContext;
PLUGIN_METABOT.MetabotContext = MetabotContext;

PLUGIN_REDUCERS.metabotPlugin = metabotReducer;
